export enum TabKeys {
  PROBLEM = 'problem',
  MESSAGES = 'messages',
  MORE = 'more',
  REPLYREQUIRED = 'reply-required',
  RESOLUTION = 'resolution',
}
